export default {
  404: {
    title: '404 Page non trouvée',
    text: "La page que vous recherchez n'est pas disponible.<br /> Essayez de revenir à la page d'accueil ou réessayez plus tard.",
  },
  500: {
    title: '500 Erreur Interne du Serveur',
    text: "Désolé, une erreur interne est survenue. <br />Nous travaillons à résoudre le problème dès que possible. <br /> Essayez de revenir à la page d'accueil ou réessayez plus tard.",
  },
}
